<script>
  export let required = false
  export let name
  export let type
  export let title
  export let value
  export let use = ()=>{}
  export let options = {}
</script>
{#if type === "select"}
  <div class="relative {$$restProps.class || ''}">
    <label for="inplace-input" class="absolute text-sm duration-300 transform -translate-y-4 scale-75 top-1 z-10 origin-[0] bg-gray-100 dark:bg-black font-bold px-1 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">{title}</label>

    <select {required} id="input-field-{name}" bind:value class="block px-2.5 pb-2.5 pt-4 w-full text-sm bg-transparent rounded-lg border-1 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer">
      {#each options as aOption}
        <option value={aOption.text} selected={aOption.text === value}>{aOption.text}</option>
      {/each}
    </select>
  </div>
{:else}
  <div class="relative {$$restProps.class || ''}">
    <label for="inplace-input" class="absolute text-sm duration-300 transform -translate-y-4 scale-75 top-1 z-10 origin-[0] bg-gray-100 dark:bg-black font-bold px-1 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-1 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">{title}</label>

    <input {required} placeholder="{title}" id="input-field-{name}" {name} type="text" bind:value use:use class="block px-2.5 pb-2.5 pt-4 w-full text-sm bg-transparent rounded-lg border-1 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"/>
  </div>
{/if}